let links = {};

export const linksConfig = {
  buyExpress: {
    en: "/express",
    sv: "/express",
    name: "Express Exchange",
    section: "Our Services"
  },
  signUp: {
    en: "/register",
    sv: "/registrera",
    name: "Standard Exchange",
    section: "Our Services"
  },
  otc: {
    en: "/otc",
    sv: "/otc",
    name: "OTC Exchange",
    section: "Our Services"
  },
  fraud: {
    en: "/fraud/",
    sv: "/fraud/",
    name: "About Frauds",
    section: "Customer information"
  },
  risks: {
    en: "/risks/",
    sv: "/risks/",
    name: "About Risks",
    section: "Customer information"
  },
  fees: {
    en: "/fees/",
    sv: "/avgifter/",
    name: "Pricing and fees",
    section: "Customer information"
  },
  contactUs: {
    en: "/support",
    sv: "/support",
    name: "Contact Us",
    section: "Customer information"
  },
  terms: {
    en: "/terms",
    sv: "/villkor",
    name: "Terms of Service",
    section: "Legal"
  },
  privacyPolicy: {
    en: "/privacy-policy",
    sv: "/privacy-policy",
    name: "Privacy Policy",
    section: "Legal"
  },
  legal: {
    en: "/legal",
    sv: "/juridik",
    name: "All Legal Documents",
    section: "Legal"
  },
  compliance: {
    en: "/compliance",
    sv: "/compliance",
    name: "Complaints Handling",
    section: "Legal"
  },
  sustainabilityIndicators: {
    en: "/sustainability-indicators",
    sv: "/hållbarhetsindikatorer",
    name: "Sustainability Indicators",
    section: "Legal"
  },

  pep: {
    en: "/are-you-a-politically-exposed-person-pep",
    sv: "/ar-du-person-i-politiskt-utsatt-stallning-pep"
  },
  faqCreditCards: {
    en: "/support/faq/exchange/#0080-why-do-i-get-an-error-message-when-i-try-to-pay-an-order-using",
    sv: "/support/faq/vaxling/#0080-varfor-far-jag-felmeddelande-nar-jag-forsoker-gora-en"
  }
};

Object.keys(linksConfig).forEach((x) => {
  links[x] = x;
});
export { links };
